import { PublicAnnouncement } from '@/api/app-state/app-state.types.ts';

interface Props {
  announcement: PublicAnnouncement;
  onClose: (id: string) => void;
}

/** Modal shown for a popup announcement until it is dismissed. */
export function AnnouncementPopup({ announcement, onClose }: Props) {
  const { id, title, body, variant, ctaLabel, ctaUrl } = announcement;

  return (
    <div
      className="eos-ann-popup__overlay"
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <div className="eos-ann-popup__dialog">
        <div className={`eos-ann-popup__accent eos-ann--${variant}`} />
        <div className="eos-ann-popup__content">
          <div className="eos-ann-popup__title">{title}</div>
          {body && <div className="eos-ann-popup__text">{body}</div>}
          <div className="eos-ann-popup__actions">
            {ctaLabel && ctaUrl && (
              <a
                className="eos-ann-popup__btn eos-ann-popup__btn--secondary eos-ann-popup__cta"
                href={ctaUrl}
                target={ctaUrl.startsWith('http') ? '_blank' : undefined}
                rel="noreferrer"
                onClick={() => onClose(id)}
              >
                {ctaLabel}
              </a>
            )}
            <button
              type="button"
              className="eos-ann-popup__btn eos-ann-popup__btn--primary"
              onClick={() => onClose(id)}
            >
              Verstanden
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
